import {useCallback, useRef} from 'react';

export const useOptimizedSearch = (api, debounceMs = 400, throttleMs = 1000) => {
  const lastCallTime = useRef(0);
  const debounceTimer = useRef(null);

  return useCallback(
    (query) => {
      // clear any pending debounce
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }

      const timeSinceLastCall = Date.now() - lastCallTime.current;

      // if we haven't reached throttle, schedule
      if (timeSinceLastCall >= throttleMs) {
        debounceTimer.current = setTimeout(() => {
          lastCallTime.current = Date.now();
          api(query);
        }, debounceMs);
      } else {
        // when we reach throttle, schedule for when throttle ends
        const remainingThrottleTime = throttleMs - timeSinceLastCall;
        debounceTimer.current = setTimeout(
          () => {
            lastCallTime.current = Date.now();
            api(query);
          },
          Math.max(debounceMs, remainingThrottleTime)
        );
      }
    },
    [api, debounceMs, throttleMs]
  );
};
